// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1Tezo","rightAdornment":"Header_rightAdornment__jCD9X"};